import type { Match, Stage } from 'modules/client/tournaments/domain/types';
import type { StageDto } from 'modules/client/tournaments/domain/types/dtos';
import extractTeamStats from 'modules/client/tournaments/domain/utils/extract-team-stats';
import { StageType } from 'modules/tournaments/domain/enums/stage-type';

function isPlayoff(stageType: StageType) {
  switch (stageType) {
    case StageType.SINGLE_ELIMINATION:
    case StageType.DOUBLE_ELIMINATION:
      return true;
    default:
      return false;
  }
}

function stageMapper(stage: StageDto, matches: Match[]): Stage {
  return {
    id: stage.id,
    name: stage.name,
    type: stage.type,
    isPlayoff: isPlayoff(stage.type),
    status: 'active',
    rounds: stage.rounds,
    teams:
      stage.stageChampionshipTable?.rows.map((stagesChampionshipTable) => {
        const teamId = stagesChampionshipTable.team.id;
        return {
          id: teamId,
          teamId: teamId,
          stageId: stage.id,
          groupId: stage.teamGroups.find((group) => {
            group.teams.find((team) => team.id === teamId);
          })?.id,
          ...extractTeamStats(stagesChampionshipTable),
        };
      }) ?? [],
    groups: stage.teamGroups.map((group) => {
      return {
        id: group.id,
        name: group.name,
        stageId: stage.id,
        teams: group.teams.map((team) => team.id),
      };
    }),
    matches: matches.filter((match) => {
      return match.stageId === stage.id;
    }),
    bracketMatches:
      stage.tournamentBrackets
        ?.map((tournamentBracket) => {
          return {
            id: tournamentBracket.id,
            stageId: stage.id,
            round: { id: tournamentBracket.round.id, name: tournamentBracket.round.name },
            roundId: tournamentBracket.round.id,
            rank: tournamentBracket.rank!,
            childBracketId: tournamentBracket.childBracket?.id ?? null,
            parentBracketIds: tournamentBracket.parentBrackets.map((bracket) => bracket.id) ?? [],
            match: tournamentBracket.match
              ? {
                  id: tournamentBracket.match.id,
                  teamMatches:
                    tournamentBracket.match.teamMatches?.map((teamMatch) => {
                      return {
                        team: teamMatch.team
                          ? {
                              id: teamMatch.team.id,
                              name: 'team',
                              shortName: 'team',
                            }
                          : null,
                        teamOrder: teamMatch.teamOrder ?? 1,
                        score: teamMatch.score ?? null,
                      };
                    }) ?? [],
                }
              : null,
            group: null,
            placeholder1: null,
            placeholder2: null,
          };
        })
        .sort(
          (a, b) =>
            stage.rounds.findIndex((round) => b.round.id === round.id) - stage.rounds.findIndex((round) => a.round.id === round.id),
        ) ?? [],
  };
}

export default stageMapper;
